import React, { Fragment, useState } from "react";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { connect } from "react-redux";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";

const VATSchema = Yup.object().shape({
  vat: Yup.number("Must be number")
    .min(1, "Should be greater than 1")
    .max(50, "Should be less than 50")
    .required("Required"),
});

const VATForm = (props) => {
  const [values, setValues] = useState({
    vat: "",
  });

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const nextClick = (values) => {
    apiJson.createStore
      .updateStoreVat({
        store: {
          vat: values.vat
        }
      })
      .then(response => {
        if (response.success) {
          props.set_store({
            store: {
              ...props.store,
              vat: values.vat,
            },
          });
          props.set_page_state({ pageState: { id: 6 } });
        }
        else {
          message = response.message;
          showError();
        }
      })
      .catch(error => {
        message = "Something went wrong!";
        showError();
      });
  };
  return (
    <Fragment>
      <Formik
        initialValues={values}
        validationSchema={VATSchema}
        isValidating={true}
        onSubmit={nextClick}
      >
        {({ values }) => {
          return (
            <Form className="form mx-auto">
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="vat"
                type="number"
                label="Value Added Tax (VAT) Percentage for your store"
                disabled={false}
              />
              <br />
              <button key={98374} type="submit" className="next-button">
                Next
              </button>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    user: state.auth.user,
  };
};

const mapDispatchTopProps = { set_store, set_page_state };

export default connect(mapStateToProps, mapDispatchTopProps)(VATForm);
